export default __webpack_public_path__ + "static/media/meter-img.47a534bb.png";